// bao migrate skip
import * as $ from "jquery";
import * as ko from "knockout";
import * as moment from "moment";
import Bao from "./../../services/bao-service";
import TabPage from "./../../factories/tab-page";
import finitoService from "./../../services/finito-service";
import BaoDialog from "./../../factories/bao-dialog";
import Guid from "./../../factories/guid";
import baoRouter from "./../../services/bao-router";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/filtering";
import GenericListTab from "./../../factories/generic-list-tab";
import { InfoTemplateDialog } from "../information";

/**
 * Class containing the functions needed for the updated DevExtreme DataGrid based Information-Tab used in reports.
 */
class ShiftReportInformationTabV2 extends GenericListTab {
    Bao = Bao;
    BaoRouterSubscriptions = [];
    CustomFilter: KnockoutObservable<any> = ko.observableArray();
    CustomFilterTemp: KnockoutObservable<any> = ko.observable();
    FormHistoryId: KnockoutObservable<any> = ko.observable();
    Infos: KnockoutObservableArray<any>;
    ItemCompleteCheck: KnockoutObservable<any> = ko.observable();
    OriginalTabTitle: string;
    ReportViewModel: any;
    SearchKey: KnockoutObservable<any> = ko.observable("InformationSearchV2");
    ShiftReport: any;
    ShowDeletedInfos: KnockoutObservable<boolean> = ko.observable();
    Subscriptions = [];
    SystemSettingNotifyWhenAddEventToClosedReport: KnockoutObservable<boolean>;
    TagValues: KnockoutObservableArray<any>;
    ValidDateJs: KnockoutObservable<string>;
    boaToolbar2ShowButton: any;
    showShowDeletedCheckbox: KnockoutObservable<any> = ko.observable();
    showShowDeletedCheckboxPermission: KnockoutObservable<boolean> = ko.observable();
    showAlert: any;
    getNavigation: any;
    Grouping: KnockoutObservableArray<any> = ko.observableArray();
    AvailableColumns: KnockoutObservableArray<any> = ko.observableArray();
    TableControlKey: KnockoutObservable<string> = ko.observable("ShiftReportDataGrid");
    TableControlLoadKey: KnockoutObservable<string> = ko.observable("ShiftReportDataGrid");

    constructor(tabPage: TabPage, parent: any) {
        super(tabPage, parent);

        this.BaoRouterSubscriptions = [];
        this.ValidDateJs = ko.observable(moment().format(Bao.Utils.DateTimeFormat));
        this.PageSize = ko.observable(10);
        this.PageIndex = ko.observable(0);
        this.Sorting = ko.observableArray([]);
        this.Grouping = ko.observableArray([]);
        this.SystemSettingNotifyWhenAddEventToClosedReport = ko.observable(false);
        this.Infos = ko.observableArray([]);
        this.TagValues = ko.observableArray([]);
        this.TotalRows = ko.observable(0);
        this.ShiftReport = parent;
        this.OriginalTabTitle = this.TabPage.Title();
        this.AvailableColumns = ko.observableArray([]);
        this.CustomFilter = ko.observableArray([]);
        this.TableControlLoadKey = ko.observable("ShiftReportDataGrid_" + this.ShiftReport.ReportId());
        this.TotalRows.subscribe((value) => {
            if (value == null || value == 0) {
                this.TabPage.Title(this.OriginalTabTitle);
                return;
            }
            this.TabPage.Title(this.OriginalTabTitle + " (" + value + ")");
        });
        this.PageIndex.subscribe(() => {
            Bao.raiseEvent("table-control:load", this.TableControlLoadKey());
        });
        this.PageSize.subscribe(() => {
            this.ResetPageIndexAndRefresh();
        });
        this.ShowDeletedInfos.subscribe(() => {
            Bao.raiseEvent("table-control:load", this.TableControlLoadKey());
        });
        this.ShiftReport.IsOriginal.subscribe((isOriginal) => {
            if (isOriginal) {
                this.CustomFilter().IsShiftClosure = false;
                this.ResetPageIndexAndRefresh();
                this.ToggleToolbarButtons();
                this.ShiftReport.toggleButtons();
                Bao.raiseEvent("table-control:hide_edit_col", this.TableControlKey());
            }
        });
        this.ShiftReport.CurrentRevision.subscribe((currentRevision) => {
            if (currentRevision) {
                this.CustomFilter().IsShiftClosure = false;
                this.ResetPageIndexAndRefresh();
                this.ToggleToolbarButtons();
                this.ShiftReport.toggleButtons();
                Bao.raiseEvent("table-control:show_edit_col", this.TableControlKey());
            }
        });
        this.ShiftReport.IsShiftClosure.subscribe((isShiftClosure) => {
            if (isShiftClosure) {
                this.CustomFilter().IsShiftClosure = true;
                this.ResetPageIndexAndRefresh();
                this.ToggleToolbarButtons();
                this.ShiftReport.toggleButtons();
                Bao.raiseEvent("table-control:show_edit_col", this.TableControlKey());
            }
        });
        this.showShowDeletedCheckboxPermission = ko.observable(false);
        this.showShowDeletedCheckbox = ko.pureComputed(() => {
            return this.showShowDeletedCheckboxPermission() && this.ShiftReport.Permissions() && this.ShiftReport.Permissions()["HasPermissionReportOptionShowDeleted"];
        });
    }

    /**
    * Initializes the toolbar's permissions and buttons via {@link SetPermissions} and {@link ToggleToolbarButtons}.
    */
    toolbarLoaded = (buttons) => {
        this.SetPermissions();
        this.ToggleToolbarButtons();
    };

    /**
    * Shows buttons based on if we have permissions for them.
    */
    SetPermissions = () => {
        let permissions = this.ShiftReport.Permissions();
        if (!permissions)
            return;
        for (let actionKey in permissions) {
            this.boaToolbar2ShowButton(actionKey, permissions[actionKey]);
        }
    };

    /**
    * enables or disables a button based on the actionKey and enabled parameters.
    */
    enableButton: (actionKey: string, enabled: boolean) => void;

    /**
    * Toggles all of the toolbar buttons inside of the tab.
    * Disabled buttons will appear as greyed out.
    */
    ToggleToolbarButtons() {
        let prefix = "action" + this.ShiftReport.FormName() + "CustomToolbarInfo";
        let hasSelection = this.Selection()?.[0] !== undefined;
        this.enableButton(prefix + "New", this.ShiftReport.IsValid.peek() && !this.ShiftReport.IsOriginal.peek());
        this.enableButton(prefix + "Edit", this.ShiftReport.IsValid.peek() && !this.ShiftReport.IsOriginal.peek() && hasSelection);
        this.enableButton(prefix + "Copy", this.ShiftReport.IsValid.peek() && !this.ShiftReport.IsOriginal.peek() && hasSelection);
        this.enableButton(prefix + 'CopyOrTransfer', this.ShiftReport.IsValid.peek() && !this.ShiftReport.IsOriginal.peek() && hasSelection);
        this.enableButton(prefix + 'BlindCopyNextShift', this.ShiftReport.IsValid.peek() && !this.ShiftReport.IsOriginal.peek() && hasSelection);
        this.enableButton(prefix + 'BlindCopyCurrentShift', this.ShiftReport.IsValid.peek() && !this.ShiftReport.IsOriginal.peek() && hasSelection);
        this.enableButton(prefix + 'ReferCurrentShift', this.ShiftReport.IsValid.peek() && !this.ShiftReport.IsOriginal.peek() && hasSelection);
        this.enableButton(prefix + 'ReferNextShift', this.ShiftReport.IsValid.peek() && !this.ShiftReport.IsOriginal.peek() && hasSelection);
        this.enableButton(prefix + "CreateNotification", this.ShiftReport.IsValid.peek() && !this.ShiftReport.IsOriginal.peek() && hasSelection);
        this.enableButton(prefix + "CreateChecklist", this.ShiftReport.IsValid.peek() && !this.ShiftReport.IsOriginal.peek() && hasSelection);
        this.enableButton(prefix + "CreateTicket", this.ShiftReport.IsValid.peek() && !this.ShiftReport.IsOriginal.peek() && hasSelection);
        this.enableButton(prefix + "Delete", this.ShiftReport.IsValid.peek() && !this.ShiftReport.IsClosed.peek() && !this.ShiftReport.IsOriginal.peek() && hasSelection);
    }

    /**
    * Handles the function called depending on which button was clicked on the toolbar.
    */
    CustomToolbarClick(button: Interfaces.Bao.BaoMenuItem) {
        let key = ko.unwrap(button.ActionKey);
        switch (key) {
            case "actionFormShiftReportCustomToolbarInfoNew":
                this.new();
                break;
            case "actionFormShiftReportCustomToolbarInfoDelete":
                this.Remove();
                break;
            case "actionFormShiftReportCustomToolbarInfoEdit":
                this.edit(null, null, false);
                break;
            case "actionFormShiftReportCustomToolbarInfoCreateChecklist":
                this.createchecklist();
                break;
            case "actionFormShiftReportCustomToolbarInfoCreateNotification":
                this.createnotification();
                break;
            case "actionFormShiftReportCustomToolbarInfoCreateTicket":
                this.createticket();
                break;
            case "actionFormShiftReportCustomToolbarInfoBlindCopyNextShift":
                this.blindcopynextshift();
                break;
            case "actionFormShiftReportCustomToolbarInfoBlindCopyCurrentShift":
                this.blindcopycurrentshift();
                break;
            case "actionFormShiftReportCustomToolbarInfoReferCurrentShift":
                this.refercurrentshift();
                break;
            case "actionFormShiftReportCustomToolbarInfoReferNextShift":
                this.refernextshift();
                break;
        }
    }

    /**
    * Sets the index of the current page of the DataGrid to 0 and triggers a reload.
    */
    ResetPageIndexAndRefresh = () => {
        this.PageIndex(0);
        Bao.raiseEvent("table-control:load", this.TableControlLoadKey());
    };

    /**
    * Return to the view of this tab. (usually used after deleting)
    */
    returnToMyself = (tabToClose) => {
        if (tabToClose) {
            this.ShiftReport.TabViewModel.RemoveTab(tabToClose);
            this.ShiftReport.TabViewModel.SelectTab(this.TabPage);
        }
    };

    /**
    * 
    */
    link = (index, infoModel) => {
        if (infoModel) {
            this.edit(infoModel.InfoId(), index(), false);
        }
    };

    /**
    * The first function called after an instance of this tab has been created
    */
    init = () => {
        this.TabPage.IsLoading(true);
        this.TabPage.IconLeft("fal fa-dot-circle");

        Bao.raiseEvent("table-control:load", this.TableControlLoadKey());

        return Bao.post("Information/GetShowDeletedPermission")
            .then((result) => {
                this.showShowDeletedCheckboxPermission(result);
            }).always(() => { this.TabPage.IsLoading(false) });
    };

    /**
    * Return to the view of this tab. (usually used after deleting)
    */
    loaded = () => {
        this.BaoRouterSubscriptions.push(baoRouter.routed((request, data) => {
            this.routeToInfo(request);
        }));
        this.routeToInfo(this.ShiftReport.TabPage);
        Bao.bindEvent("informations:refresh", (value) => {
            if (value.ReportId == this.ShiftReport.ReportId()) {
                this.TotalRows(undefined);
                Bao.raiseEvent("table-control:load", this.TableControlLoadKey());
            }
        });
        this.ValidDateJs.subscribe((validDateJs) => {
            this.getNavigation(validDateJs);
        });
        this.TabPage.IsLoading(false);
        if (this.ShiftReport.IsOriginal()) {
            Bao.raiseEvent("table-control:hide_edit_col", this.TableControlKey());
        }
        return Bao.post("InformationV2/GetAllDatagridColumns", JSON.stringify({
            reportId: this.ShiftReport.ReportId()
        })).then(result => {
            this.AvailableColumns(result);
            Bao.raiseEvent("table-control:load", this.TableControlLoadKey());
        })
    };

    /**
    * Dispose of all Subscriptions
    */
    dispose = () => {
        ko.utils.arrayForEach(this.BaoRouterSubscriptions, (subscription) => {
            baoRouter.unsubscribe(subscription);
        });
        ko.utils.arrayForEach(this.Subscriptions, (subscription: any) => {
            subscription.dispose();
        });
    };

    /**
    * turns the provided CustomFilter into a HashObject
    */
    ToHashObject = (customFilter) => {
        let returnValue = [];
        for (let f in customFilter) {
            returnValue.push({
                Key: f,
                Value: ko.unwrap(customFilter[f])
            });
        }
        return returnValue;
    };

    /** 
     * copies selected information into the next shift
    */
    blindcopynextshift = () => {

        this.copyreferinfo(
            'BlindCopy',
            { reportId: this.ShiftReport.ReportId() },
            'BlindCopy',
            ''
        );
    };

    /** 
     * copies selected information in the current shift
    */
    blindcopycurrentshift = () => {
        this.copyreferinfo(
            'BlindCopy',
            { shiftbookId: this.ShiftReport.ShiftbookId() },
            'BlindCopyToCurrent',
            'Current'
        );
    };

    /** 
     * refers selected information in the current shift
    */
    refercurrentshift = () => {
        this.copyreferinfo(
            'TransferCopy',
            {
                shiftbookId: this.ShiftReport.ShiftbookId(),
                openReportId: this.ShiftReport.ReportId()
            },
            'TransferCopyToCurrent',
            'Current'
        );
    };

    /** 
     * refers selected information into the next shift
    */
    refernextshift = () => {
        this.copyreferinfo(
            'TransferCopy',
            { reportId: this.ShiftReport.ReportId() },
            'TransferCopy',
            ''
        );
    };

    /**
    * Function for copying or referring shift events
    * @param method (BlindCopy or TransferCopy)
    * @param data (IDs that should be sent to the backend)
    * @param url (Endpoint name)
    * @param type (Current or next)
    */
    copyreferinfo = (method, data, url, type) => {
        let selection = this.Selection()[0].InfoId;
        if (selection != null) {
            let dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage('Info' + method + type + 'Question'), 'yesno');
            dialog.DialogResult.subscribe((canCopy) => {
                if (canCopy) {
                    this.TabPage.IsLoading(true);
                    let infoIds = ko.observableArray();
                    infoIds.push(selection);

                    Bao.post('Information/' + url, JSON.stringify({
                        id: (<any>this.TabPage).FormHistoryId,
                        infoIds: infoIds(),
                        ...data
                    })).then((copied) => {
                        if (copied) {
                            this.ShowAlert('Info' + method + type + 'Successful');
                        } else {
                            this.ShowAlert('Info' + method + type + 'Error', 'danger');
                        }
                        Bao.raiseEvent("table-control:load", this.TableControlLoadKey());
                        this.TabPage.IsLoading(false);
                    });
                }
            });
        }
    };

    /**
     * Removes the currently selected Information
    */
    Remove = () => {
        let def = $.Deferred<void>();

        if (this.Selection().length > 0) {
            let dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.InfoDeleteQuestion), "yesno");
            dialog.DialogResult.subscribe((canDelete) => {
                if (canDelete) {
                    this.TabPage.IsLoading(true);

                    Bao.post("InformationV2/Remove", JSON.stringify({
                        reportId: this.ShiftReport.ReportId(),
                        infoId: this.Selection()[0].InfoId
                    })).then((deleted) => {
                        if (deleted > 0) {
                            let infoTab = this.getInfoTab();
                            if (infoTab) {
                                if (infoTab.ViewModel().InfoId() == this.Selection()[0].InfoId) {
                                    this.ShiftReport.TabViewModel.RemoveTab(infoTab);
                                }
                            }
                            this.ShowAlert(finitoService.MessageKeys.InfoDeleteSuccessful);
                        }
                        else {
                            this.ShowAlert(finitoService.MessageKeys.InfoDeleteError, "danger");
                        }
                        Bao.raiseEvent("table-control:load", this.TableControlLoadKey());
                        this.TabPage.IsLoading(false);
                    });
                }
            });
        }
        return def.promise();
    }

    /**
     * Creates a dialog for triggering a new SAP-PM notification
     */
    createnotification = () => {
        if (this.Selection().length > 0) {
            this.TabPage.IsLoading(true);
            let notifCreated = false;

            let infoId = this.Selection()[0].InfoId

            return Bao.post("Information/CheckInfoSap", JSON.stringify({
                infoId: infoId
            }), (result) => {
                notifCreated = result.Message;
                if (!notifCreated) {
                    window.baorequire(["ViewModels/Dialogs/InfoSapDialog"], (vm) => {
                        let dialog;
                        if (infoId != null) {
                            dialog = new vm(this.TabPage);
                            dialog.Show(infoId, this.TabPage);
                            this.TabPage.IsLoading(false);
                        }
                    });
                }
                else {
                    new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgSapExist"), "info");
                }
                this.TabPage.IsLoading(false);
            });
        }
    };

    /**
     * Create a checklist
     */
    createchecklist = () => {
        if (this.Selection().length > 0) {
            this.ReportViewModel = this.ShiftReport;
            let count = 0;
            return Bao.post("Dialog/GetInfoChecklistsByShiftbookId", JSON.stringify({
                shiftbookId: this.ReportViewModel.ShiftbookId()
            }), (result) => {
                if (result != null) {
                    count = result.length;
                }
                if (count === 1) {
                    this.CreateEvaluation(result[0], this.ReportViewModel.ReportId());
                }
                else {
                    window.baorequire(["ViewModels/Dialogs/CreateEvaluationDialog"], (vm) => {
                        let dialog = new vm(this.TabPage, self);
                        dialog.Show();
                        dialog.DialogResult.subscribe((dialogResult) => {
                            if (dialogResult) {
                                this.CreateEvaluation(dialog.DialogViewModel.FolderStructureChecklistId(), this.ReportViewModel.ReportId());
                            }
                        });
                    });
                }
            });
        }
    };

    /**
     * Create an evaluation tied to the info for the checklist chosen in the create checklist dialog
     * @param folderStructureChecklistId 
     * @param reportId 
     * @returns 
     */
    CreateEvaluation = (folderStructureChecklistId, reportId) => {
        this.TabPage.IsLoading(true);
        let infoId = this.Selection()[0].InfoId;
        return Bao.post("EvaluationTab/CreateEvaluationByReport", JSON.stringify({
            folderStructureChecklistId: folderStructureChecklistId,
            reportId: reportId,
            infoId: infoId
        }), (result) => {
            if (result) {
                baoRouter.setHash("checkware/evaluation/" + result);
            }
            this.TabPage.IsLoading(false);
        });
    };

    /**
     * Create a ticket tied to the selected info
     */
    createticket = () => {
        let AppTabController = window.baorequire("Services/AppTabController");
        if (this.Selection().length > 0) {
            let infoId = this.Selection()[0].InfoId;
            Bao.post("Information/GetInformation", JSON.stringify({
                reportId: this.ShiftReport.ReportId,
                infoId: infoId,
                isOriginal: false
            }), (result) => {
                let newTicketTab = new TabPage("NewTicket");
                newTicketTab.IsClosable(true);
                newTicketTab.AutoSelect = true;
                newTicketTab.PreLoad(true);
                newTicketTab.Visible(true);
                newTicketTab.Url("Ticket/Index");
                newTicketTab.UrlData({
                    infoId: result.InfoId,
                    problemText: result.InfoText
                });
                AppTabController.AddTab(newTicketTab);
            });
        }
    };

    /**
     * Returns the current custom filters
     */
    GetCustomFilter = () => {
        let iObject = 0;
        let customFilterHashObject = [];
        if (this.CustomFilterTemp() != null) {
            $.each(this.CustomFilterTemp(), (key, value) => {
                let hashObject: any = {};
                hashObject.Key = key;
                hashObject.Value = value;
                customFilterHashObject[iObject] = hashObject;
                iObject++;
            });
        }
        return customFilterHashObject;
    };

    executeSearchItems = async (headerFilters, customFilters, skip, take, sortingParam) => {
        let url = "InformationV2/SearchItems";
        if (headerFilters?.length > 0) {
            url += "?$filter=" + headerFilters;
            url = encodeURI(url);
        }
        const result = await Bao.post(url, JSON.stringify({
            searchKey: this.SearchKey === undefined ? "" : this.SearchKey(),
            customFilter: customFilters,
            skip: skip,
            take: take,
            sorting: sortingParam
        }));
        this.TabPage.IsLoading(false);
        if (result != null) {
            return {
                data: result.Models,
                totalCount: result.TotalRows
            };
        }
        else {
            return null;
        }
    }

    executeSearchGroups = async (headerFilters, customFilters, skip, take, sortingParam, groupingParam) => {
        let url = "InformationV2/SearchGroups";
        if (headerFilters?.length > 0) {
            url += "?$filter=" + headerFilters;
            url = encodeURI(url);
        }
        const result = await Bao.post(url, JSON.stringify({
            searchKey: this.SearchKey === undefined ? "" : this.SearchKey(),
            customFilter: customFilters,
            skip: skip,
            take: take,
            sorting: sortingParam,
            grouping: groupingParam
        }));
        this.TabPage.IsLoading(false);
        if (result != null) {
            return {
                data: result.Models,
                groupCount: result.GroupCount,
                totalCount: result.TotalCount
            };
        }
        else {
            return null;
        }
    }

    /**
    * Get all of the rows for the DataGrid depending on the supplied parameters
    * @param headerFilters - Filters used in the request URL (see {@link https://learn.microsoft.com/en-us/odata/concepts/queryoptions-overview})
    * @param skip - The number of rows to skip
    * @param take - The number of rows to take
    * @param sortingParam - The columns to sort by and the direction to sort
    * @param groupingParam - The columns to group by
    */
    loadTableControlData = async (headerFilters, skip, take, sortingParam, groupingParam) => {

        this.TabPage.IsLoading(true);
        let customFilters = this.GetCustomFilter();
        customFilters.push({ Key: "ReportId", Value: this.ShiftReport.ReportId() });
        customFilters.push({ Key: "IncludeDeleted", Value: this.ShowDeletedInfos() });
        customFilters.push({ Key: "IsOriginal", Value: this.ShiftReport.IsOriginal.peek() });
        customFilters.push({ Key: "IsShiftClosure", Value: this.ShiftReport.IsShiftClosure.peek() });
        customFilters.push({ Key: "ShowTransferedInfos", Value: true });

        let result = null;
        this.Sorting(sortingParam);

        if (groupingParam !== null && groupingParam.length > 0) {
            /* if we don't have the total rows yet, we need to get them first */
            result = await this.executeSearchGroups(headerFilters, customFilters, skip, take, sortingParam, groupingParam);
        } else {
            result = await this.executeSearchItems(headerFilters, customFilters, skip, take, sortingParam);
        }

        if (headerFilters == null) {
            this.TotalRows(result.totalCount);
        }

        this.TabPage.IsLoading(false);
        return result;
    }

    /**
     * Gets the EdmModel for the DataGrid (Each DataType of the InfoModel-Properties)
    */
    loadModelMetadata = () => {
        return Bao.post("Search/GetModelMetadata", JSON.stringify({
            searchKey: "InformationSearchV2"
        })).then(result => {
            return result?.EdmModel;
        });
    }

    /**
     * 
     * Custom function that executes when a user clicks on the edit row button in the table control
     * @param rowData An object containing row data
     */
    customEditEntryFunction = (rowData) => {
        this.edit(rowData.InfoId, null, false);
    }

    /**
     * Creates a new Detail tab, allowing the user to edit the currently selected information or to create a new one
     * @param newInfo - Whether or not to create a new information
     */
    createNewInfoTab = (newInfo: boolean) => {
        let newTab = this.ShiftReport.TabViewModel.SearchTabByObjectId("ActiveInfo");
        if (!newTab) {
            newTab = new TabPage("ActiveInfo");
            newTab.AutoSelect = false;
            newTab.Url("Information/Detail");
            newTab.UrlData({
                id: (<any>this.TabPage).FormHistoryId,
                reportId: this.ShiftReport.ReportId(),
                shiftbookId: this.ShiftReport.ShiftbookId()
            });
            newTab.IsClosable(true);
            newTab.PreLoad(true);
            newTab.Visible(true);
            newTab.FormHistoryId = (<any>this.TabPage).FormHistoryId;
            newTab.InformationTab = self;
            newTab.AlreadyLoaded = false;
            if (!newInfo) {
                this.ShiftReport.TabViewModel.AddTab(newTab);
            }
        }
        return newTab;
    };

    /**
     * Get the Info tab of a selected information
     */
    getInfoTab = () => {
        return this.ShiftReport.TabViewModel.SearchTabByObjectId("ActiveInfo");
    };

    /**
     * Opens a new Detail tab via {@link OpenNewShiftEvent}, allowing the user to create a new information
    */
    new = () => {
        if ((!this.SystemSettingNotifyWhenAddEventToClosedReport() || this.ShiftReport.IsClosed() !== true) && this.ShiftReport?.Permissions()?.actionFormShiftReportCustomToolbarActiveInfoNew) {
            this.OpenNewShiftEvent();
            return;
        }
        let yesnodialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.AddEventToClosedReport), "yesno");
        yesnodialog.DialogResult.subscribe((dialogresult) => {
            if (dialogresult && this.ShiftReport?.Permissions()?.actionFormShiftReportCustomToolbarActiveInfoNew) {
                this.OpenNewShiftEvent();
            }
        });
    };

    /**
     * Opens a new Information according to the selected template via {@link CreateInfoTemplateDialog}
     */
    OpenNewShiftEvent = () => {
        let infoTab = this.createNewInfoTab(true);
        if (infoTab) {
            this.CreateInfoTemplateDialog()
                .then(infoTemplateId => {
                    this.ShiftReport.TabViewModel.AddTab(infoTab);
                    let newInfoId = Guid();
                    infoTab.InfoId = newInfoId;
                    infoTab.InfoTemplateId = infoTemplateId;
                    infoTab.IsNew = true;
                    this.loadTab(infoTab, true, newInfoId, null);
                });
        }
    };

    /**
     * Opens the template dialog for creating a new info
     * @returns {JQueryPromise<any>}
     */
    CreateInfoTemplateDialog = () => {
        let def = $.Deferred();
        this.TabPage.IsLoading(true);
        let infoTemplateDialog = new InfoTemplateDialog(this.TabPage);
        infoTemplateDialog.OpenDialog(this.ShiftReport.ShiftbookId())
            .then((infoTemplate: any) => {
                let infoTemplateId = null;
                if (infoTemplate != null) {
                    if (infoTemplate !== false) {
                        infoTemplateId = infoTemplate.InfoTemplateId;
                    }
                    def.resolve(infoTemplateId);
                }
                else {
                    def.reject();
                }
            });
        return def.promise();
    }

    /**
     * Load the Tab passed as parameter
     * @param tab - instance of the tab
     * @param isNew - is the tab new
     * @param infoId - infoid tied to the tab
     * @param listIndex - index of the tab
     */
    loadTab = (tab, isNew, infoId, listIndex) => {
        this.ShiftReport.TabViewModel.SelectTab(tab);
        if (tab.AlreadyLoaded) {
            let tabViewModel = tab.ViewModel();
            tabViewModel.BeforeClose(() => {
                tab.IsNew = isNew;
                tab.InfoId = infoId;
                tab.ListIndex = listIndex;
                tabViewModel.init().then(tabViewModel.loaded).then(() => {
                    tabViewModel.PagingEnabled(true);
                    this.ShiftReport.TabViewModel.SelectTab(tabViewModel.TabPage);
                });
            }, true);
        }
    };

    /**
     * set the index if infoid is matched into the infos array  
    */
    GetIndexByInfoId = (infoId, index) => {
        if (index == null) {
            let i = 0;
            ko.utils.arrayForEach(this.Infos(), (item: any) => {
                if (item.InfoId() == infoId) {
                    index = i;
                }
                i++;
            });

        }
        return index;
    };

    /**
     * Edit the selected info
     * @param infoId - ID of the info to edit
     * @param index - index of the info (alternatively provided to the id)
     * @param ignoreIndex - if we should ignore the index
     */
    edit = (infoId, index, ignoreIndex) => {
        if (infoId == null || index == null && !ignoreIndex) {
            if (this.Selection().length > 0) {
                if (infoId == null) {
                    infoId = this.Selection()[0].InfoId;
                }
                index = this.GetIndexByInfoId(infoId, index);
            }
            else {
                return;
            }
        }
        if (index != null) {
            index = index + this.PageIndex() * this.PageSize();
        }
        let tabAlreadyOpened = this.ShiftReport.TabViewModel.SearchTabByObjectId("ActiveInfo") != null;

        let infoTab = this.createNewInfoTab(false);
        if (infoTab) {
            if (!tabAlreadyOpened) {
                infoTab.IsNew = false;
                infoTab.InfoId = infoId;
                infoTab.ListIndex = index;
            }
            this.loadTab(infoTab, false, infoId, index);
        }

    };

    /**
     * Remove the InfoId from the current URL
    */
    removeInfoIdFromRoute = () => {
        let currentHash = baoRouter.getHash(), infoIdIndex = currentHash.toLowerCase().indexOf('info');
        if (infoIdIndex !== -1) {
            baoRouter.replaceHash(currentHash.substr(0, infoIdIndex));
        }
    };

    /**
     * Route to the currently selected Information and either open up a new detail tab or load an existing one
     * @param tabPage - tab page to route to
     */
    routeToInfo = (tabPage) => {
        let infoId = baoRouter.getRouteValue("infoid", tabPage);
        if (this.TabPage.IsActiveTab() || infoId) {
            let reportId = baoRouter.getRouteValue("id", tabPage);
            if (reportId === this.ShiftReport.ReportId() && infoId) {
                this.removeInfoIdFromRoute();
                let activeInfoTab = this.ShiftReport.TabViewModel.SearchTabByObjectId("ActiveInfo");
                let index = null, i = 0, ignoreIndex = true;
                ko.utils.arrayForEach(this.Infos(), (item: any) => {
                    if (item.InfoId() == infoId) {
                        ignoreIndex = false;
                        index = i;
                    }
                    i++;
                });
                if (activeInfoTab) {
                    if (ko.isObservable(activeInfoTab.ViewModel)) {
                        let infoViewModel = activeInfoTab.ViewModel();
                        if (infoViewModel) {
                            if (infoViewModel.InfoId() === infoId) {
                                this.ShiftReport.TabViewModel.SelectTab(infoViewModel.TabPage);
                            }
                            else {
                                this.edit(infoId, index, ignoreIndex);
                            }
                        }
                    }
                }
                else {
                    this.edit(infoId, index, ignoreIndex);
                }
            }
        }
    };
}
export default ShiftReportInformationTabV2;